module.exports = __webpack_public_path__ + "assets/img/social-3.05d7a83c.svg";